import { ChangeDetectionStrategy, Component, Input, OnInit, Type } from '@angular/core';
import { map } from 'rxjs/operators';
import { LtbDataService } from '../ltb-usage/ltb.data.service';
import { TitleService } from '../shared/services/title.service';
import { SnEnvService } from '@insight/serenity-env';
import { HttpService } from '../services/http.service';
import { ChargeCategoryDTO } from '../shared/api/models';
import { ConfirmationDialogService } from './confirm-dialog/confirm-dialog.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'e2cb-bulk-usage',
  templateUrl: './bulk-usage.component.html',
  styleUrls: ['./bulk-usage.component.scss']
})

export class BulkUsageComponent implements OnInit {
  public files: Set<File> = new Set();
  showSpinner: boolean = false;
  doesFileExist: boolean = false;
  fileCreationTime;

  public chargeCategoryName: string = "";
  public chargeCategoryErrorMessage: string = "";
  public chargeCategoryResults: ChargeCategoryDTO[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    private _titleService: TitleService,
    private ltbDataService: LtbDataService,
    private envService: SnEnvService,
    private httpService: HttpService,
    private confirmationDialogService: ConfirmationDialogService
  ) {
    this._titleService.Subtitle = 'Bulk Usage Options';
  }

  ngOnInit(): void { }

  async onGtvChargeCategoryLookup() {
    this.chargeCategoryResults = [];
    this.chargeCategoryErrorMessage = "";

    const url = `${this.envService.get("api_url")}gtv/chargecategorylookup/${this.chargeCategoryName}`;
    this.chargeCategoryResults = await this.httpService.get<ChargeCategoryDTO[]>(url, null).toPromise();

    if (this.chargeCategoryResults.length === 0) {
      this.chargeCategoryErrorMessage = "No matching results found.";
    } else if (this.chargeCategoryResults.length > 1) {
      this.chargeCategoryErrorMessage = "GTV returned multiple results; shown below.";
    }
  }

  onAccrualDownloadClick() {
    this.showSpinner = true;
    this.ltbDataService.GetLtbAccrualFile()
      .pipe(map((res) => {
        return {
          filename: 'manual_usage_accrual.xlsx',
          data: new Blob(
            [res['body']],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          ),
        };
      }))
      .subscribe(res => {
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(res.data, res.filename);
        } else {
          const link = window.URL.createObjectURL(res.data);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = link;
          a.download = res.filename;
          a.click();
          window.URL.revokeObjectURL(link);
          a.remove();
        }
      }, error => {
        this.handleError(error);
      }, () => {
        this.showSpinner = false;
      });
  }

  onValidationDownloadClick() {
    this.checkForFileExistence();
  }

  checkForFileExistence() {
    this.showSpinner = true;
    this.ltbDataService.CheckValidationFileExistence()
      .pipe(map((res) => {
        return {
          data: res['body'],
        };
      }))
      .subscribe(res => {
        if (res.data) {
          this.doesFileExist = res.data['status'];
          this.fileCreationTime = res.data['creationTime'] ? new Date(res.data['creationTime']).toLocaleString() : "";

          if (this.doesFileExist) {
            this.showSpinner = false;
            this.openConfirmationDialog();
          } else {
            this.unsubscribePrevPollingSubscriptions();
            this.generateValidationFile('create');
          }
        } else {
          this.showSpinner = false;
        }

      },
        error => {
          this.handleError(error);
        },
        () => { });
  }

  generateValidationFile(fileAction: string): void {
    this.showSpinner = true;
    this.ltbDataService.GenerateValidationFile(fileAction)
      .subscribe(res => {
        this.showSpinner = false;
        if (res) {
          alert('File creation has started...will get downloaded once completed.');
          this.startPollingForFileExistence();
        } else {
          this.handleError('some error occurred');
        }
      }, error => {
        this.handleError(error);
      }, () => {
        this.showSpinner = false;
      });
  }

  downloadValidationFile(): void {
    this.showSpinner = true;
    this.ltbDataService.DownloadValidationFile()
      .pipe(map((res) => {
        return {
          filename: 'usage_validation.xlsx',
          data: new Blob(
            [res['body']],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          ),
        };
      }))
      .subscribe(res => {
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(res.data, res.filename);
        } else {
          const link = window.URL.createObjectURL(res.data);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = link;
          a.download = res.filename;
          a.click();
          window.URL.revokeObjectURL(link);
          a.remove();
        }
      }, error => {
        this.handleError(error);
      }, () => {
        this.showSpinner = false;
      });
  }

  startPollingForFileExistence(): void {
    const subscriptions$ = this.ltbDataService.PollForValidationFile()
      .pipe(map((res) => {
        return {
          data: res['body'],
        };
      }))
      .subscribe(res => { },
        error => {
          this.handleError(error);
        },
        () => {
          console.log("polling completed");
          this.downloadValidationFile();
        });

    this.subscriptions.push(subscriptions$);

  }

  openConfirmationDialog(): void {
    this.confirmationDialogService.confirm('Please confirm..', `Do you want to download the file created on ${this.fileCreationTime} or overwrite it ?`)
      .then((confirmed) => {
        if (confirmed) {
          this.downloadValidationFile();
        } else {
          this.unsubscribePrevPollingSubscriptions();
          this.generateValidationFile('overwrite');
        }
      })
      .catch(() => console.log('User dismissed the dialog'));
  }

  unsubscribePrevPollingSubscriptions() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onClientMappingFileDownloadClick(): void {
    this.showSpinner = true;
    this.ltbDataService.GetClientMappingFile()
      .pipe(map((res) => {
        return {
          filename: 'client_mapping_file.xlsx',
          data: new Blob(
            [res['body']],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          ),
        };
      }))
      .subscribe(res => {
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(res.data, res.filename);
        } else {
          const link = window.URL.createObjectURL(res.data);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = link;
          a.download = res.filename;
          a.click();
          window.URL.revokeObjectURL(link);
          a.remove();
        }
      }, error => {
        this.handleError(error);
      }, () => {
        this.showSpinner = false;
      });
  }

  private handleError(error: any): void {
    this.showSpinner = false;
    alert('An error occurred. Please see console log.');
    console.log(error);
  }
}
